import './App.css';
import Header from './GIS-ge/header/header'
import Model1 from './GIS-ge/model1/Model1';
import Footer from './GIS-ge/Footer/Footer';
import Cover from './GIS-ge/cover/cover';
import Stack from './GIS-ge/stack/stack';

function App() {
  return (
    <div>
      <Header />
      <Cover />
      <section id="about">
        <Stack />
      </section>
      <section id="contacts">
        <Footer />
      </section>
    </div>
  );
}

export default App;
